import MapContext from "../../services/context/map-context";
import { useMapbox } from "./use-mapbox";

// style
import "mapbox-gl/dist/mapbox-gl.css";
import "./map.css";

export const MapboxProvider = ({ children, mapId = "map", className = "" }) => {
  const { mapContainerRef, map, mapLoaded } = useMapbox();

  return (
    <MapContext.Provider
      value={{
        map,
        mapLoaded,
      }}
    >
      <div className={`mapbox-provider ${className}`}>
        <div
          id={mapId}
          ref={mapContainerRef}
          className="mapbox-provider__canvas"
        />
        {map && children}
      </div>
    </MapContext.Provider>
  );
};
